// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ieukprkpvqjjaoigjydc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlldWtwcmtwdnFqamFvaWdqeWRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY5NjkxMzgsImV4cCI6MjA2MjU0NTEzOH0.Ej0grxwN-lbbPbB9Kj1GlI65gLWIN9-eYJnjLKzGSk0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);